var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-button',{staticClass:"search-item-alert",class:{
    active: _vm.search.send_by_email
  },attrs:{"title":_vm.search.send_by_email
    ? _vm.$t('offers.searches.disable_alert')
    : _vm.$t('offers.searches.enable_alert'),"size":"sm"},on:{"click":_vm.toggle},scopedSlots:_vm._u([{key:"left-icon",fn:function(){return [_c('ui-ctk-icon',{staticClass:"tw-m-auto",class:_vm.search.send_by_email ? 'tw-text-green-500' : 'tw-text-gray-700',attrs:{"name":_vm.search.send_by_email
        ? 'alert-on'
        : 'alert-off'}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }